module.exports = __webpack_public_path__ + "img/fireCNew.a2f89dd9.png";